export default __webpack_public_path__ + "static/media/Series-800-HPN-Inline.6a69fe8e.png";